import { render } from "./ProductAggregated.vue?vue&type=template&id=726b0d6e&ts=true"
import script from "./ProductAggregated.vue?vue&type=script&lang=ts"
export * from "./ProductAggregated.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__